import type { BulkOnboardSession } from "../BulkOnboardSession";

export const useDeletePropertyHandler = (id: number, onDelete?: () => void) => {
    const removeProperty = () => {
        const onboardSessionStorage = sessionStorage.getItem("bulkOnboardingSession");

        if (onboardSessionStorage !== null) {
            const onboardSession: BulkOnboardSession = JSON.parse(onboardSessionStorage);

            // remove the property from the session data, either by propertyId or onboardingId
            onboardSession.properties = onboardSession.properties.filter(
                (p) => p.propertyId !== id.toString() && p.onboardingId !== id.toString(),
            );

            sessionStorage.setItem("bulkOnboardingSession", JSON.stringify(onboardSession));
        }

        onDelete?.();
    };

    return removeProperty;
};
